import StatisticsManagement from "./statistics-management.page";

export default StatisticsManagement;
